import styled from "styled-components";

export const AuthenticationContainer = styled.div`
  width: 900px;
  display: flex;
  justify-content: space-between;
  margin: 30px auto;
`;
